import { createFileRoute } from "@tanstack/react-router"

import PhasingOutOverview from "~/components/product-management/tabs/PhasingOutTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/product-management/_layout/phasing-out")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Product Management - Phasing Out")
  return <PhasingOutOverview />
}
